import { useTheme } from '@mui/material';

export const BenefitQuestionsIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3078_45785)">
                <rect
                    x="19.25"
                    y="14"
                    width="31.5"
                    height="40.25"
                    rx="2"
                    fill={primaryBackground}
                />
                <path
                    d="M42 9.33333C42.6188 9.33333 43.2123 9.57917 43.6499 10.0168C44.0875 10.4543 44.3333 11.0478 44.3333 11.6667V46.6667C44.3333 47.2855 44.0875 47.879 43.6499 48.3166C43.2123 48.7542 42.6188 49 42 49H14C13.3811 49 12.7876 48.7542 12.35 48.3166C11.9125 47.879 11.6666 47.2855 11.6666 46.6667V11.6667C11.6666 11.0478 11.9125 10.4543 12.35 10.0168C12.7876 9.57917 13.3811 9.33333 14 9.33333"
                    stroke={primaryStroke}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28 32.6667V31.5C28 31.1906 28.1229 30.8938 28.3417 30.675C28.5605 30.4562 28.8572 30.3333 29.1667 30.3333C30.0949 30.3333 30.9852 29.9646 31.6415 29.3082C32.2979 28.6518 32.6667 27.7616 32.6667 26.8333V26.8333C32.6667 25.9051 32.2979 25.0148 31.6415 24.3585C30.9852 23.7021 30.0949 23.3333 29.1667 23.3333H25.6667M32.6667 14H23.3333C22.7145 14 22.121 13.7542 21.6834 13.3166C21.2458 12.879 21 12.2855 21 11.6667V9.33333C21 8.71449 21.2458 8.121 21.6834 7.68342C22.121 7.24583 22.7145 7 23.3333 7H32.6667C33.2855 7 33.879 7.24583 34.3166 7.68342C34.7542 8.121 35 8.71449 35 9.33333V11.6667C35 12.2855 34.7542 12.879 34.3166 13.3166C33.879 13.7542 33.2855 14 32.6667 14Z"
                    stroke={primaryStroke}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.8833 39.6667H28.1166"
                    stroke={primaryStroke}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3078_45785">
                    <rect width="56" height="56" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
